import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { parseError } from 'utils/helpers';
import logo from './img/logo.svg'
import axios from 'axios'
import { useStore } from 'store'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import Stepper from 'components/Stepper/Stepper';
import GoogleSign from 'components/GoogleSign/GoogleSign';

const UserSignup = () => {
    const navigate = useNavigate()
    const { type } = useParams();
    const [step, setStep] = useState(0);
    const [termsAccept, setTermsAccept] = useState(false);
    const [termsError, setTermsError] = useState(false);
    const [isGoogleAuth, setIsGoogleAuth] = useState(false);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
    })
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [cost, setCost] = useState([]);
    const [rate, setRate] = useState();
    const [dobState, setDobState] = useState('');
    const [addressState, setAddressState] = useState({
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        country: 'United States of America',
        countryCode: 'US',
    });
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isPhoneVerified, setIsPhoneVerified] = useState(false);
    const [isAddressVerified, setIsAddressVerified] = useState(false);
    const [finishing, setFinishing] = useState(false);

    const [error, setError] = useState({})


    useEffect(() => {
        if (type !== 'caregiver' && type !== 'customer') {
            navigate(`/`)
        }
    }, [type])

    const maxSteps = useMemo(() => (type === 'customer' ? 3 : 4), [type]);
    const store = useStore();
    const signInfo = useMemo(
        () => ({
            name,
            surname,
            email,
            password,
            rate,
            cost,
            dob: dobState,
            address: addressState,
            phone: 123,
            isPhoneVerified,
            isAddressVerified,
        }),
        [
            name,
            surname,
            email,
            password,
            rate,
            cost,
            dobState,
            addressState,
            phoneNumber,
            isPhoneVerified,
            isAddressVerified
        ]
    );


    const googleSing = useCallback((data) => {
        if (data.email) {
            setIsGoogleAuth(true);
            setEmail(data.email);
            setPassword(null);
            if (data.given_name) setName(data.given_name);
            if (data.family_name) setSurname(data.family_name);
        }
    }, []);

    useEffect(() => {
        document.body.classList.add("tailwind-body");

        return () => {
            document.body.classList.remove("tailwind-body");
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const finishSignup = useCallback(() => {
        setFinishing(true);
        const userType = type === 'caregiver' ? 'provider' : type;
        axios
            .post(`/auth/signup/${userType}`, signInfo)
            .then(({ data }) => {
                store.auth.authorize(data.token, userType);
                localStorage.setItem('hasSignedUp', true);
                if (userType === 'provider') {
                    navigate('/profile');
                } else {
                    navigate('/');
                }
            })
            .catch((e) => {
                setStep(0);
                setError(parseError(e));
                setFinishing(false);
            });
    }, [type, signInfo, navigate, store.auth]);


    const startSignup = useCallback((e) => {
        e.preventDefault()
        if (!termsAccept) {
            setTermsError(true)
            return
        } else {
            setTermsError(false)
        }

        if (!isGoogleAuth && signInfo.password !== passwordRepeat) {
            return setError({
                type: 'error',
                message: 'Passwords do not match'
            })
        }

        const userType = type === 'caregiver' ? 'provider' : type;

        axios
            .post(`/auth/signup/${userType}/validate`, signInfo)
            .then(() => {
                if (isGoogleAuth) {
                    if (userType === 'provider') setStep(2);
                    if (userType === 'customer') /*finishSignup();*/setStep(2)
                } else {
                    setStep(1);
                }
            })
            .catch((e) => {
                setError(parseError(e));
            });
    }, [
        type,
        passwordRepeat,
        isGoogleAuth,
        termsAccept,
        signInfo,
        finishSignup,
    ]);

    const selectCategory = useCallback((cat) => {
        setCost((cost) => {
            const index = cost.findIndex((cost) => cost.title === cat);

            if (index >= 0) {
                const updatedCost = [...cost.slice(0, index), ...cost.slice(index + 1)];
                return updatedCost;
            } else {
                const newCost = { title: cat, price: '' };
                return [...cost, newCost];
            }
        });
    }, []);

    const setCategoryRate = useCallback((cat, price) => {
        setCost((cats) => {
            const index = cats.findIndex((item) => item.title === cat);
            if (index >= 0) {
                cats[index] = { title: cat, price };
            }
            return [...cats];
        });
    }, []);

    const onAddressChange = useCallback((name, value) => {
        setAddressState((previousState) => ({
            ...previousState,
            [name]: value,
        }));
    }, []);

    const onDobChange = useCallback((dob) => {
        setDobState(dob);
    }, []);

    const onNextStep = useCallback(() => {
        if (step >= maxSteps) {
            return finishSignup();
        } else {
            setStep((step) => step + 1);
        }
    }, [step, maxSteps, finishSignup]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            {step === 0 && (
                <>
                    <div className="sm:mx-auto sm:w-full sm:max-w-md">
                        <a href="/" className="flex justify-center items-center space-x-2 mb-8">
                            <img
                                src={logo}
                                alt="Emissary Care"
                                className="h-12 w-auto"
                            />
                            <span className="text-xl font-semibold bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">
                                Emissary Care
                            </span>
                        </a>
                        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">
                            Create your account
                        </h2>
                        <p className="mt-2 text-center text-sm text-gray-600">
                            Start your journey to better care today
                        </p>
                    </div>

                    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                            <form className="space-y-6" onSubmit={startSignup}>
                                <GoogleSign onUserInfo={googleSing} type="up" />
                                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                                    <div>
                                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                            First name
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                id="firstName"
                                                name="firstName"
                                                type="text"
                                                required
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                className="input-primary"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                            Last name
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                id="lastName"
                                                name="lastName"
                                                type="text"
                                                required
                                                value={surname}
                                                onChange={(e) => setSurname(e.target.value)}
                                                className="input-primary"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                        Email address
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            required
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="input-primary"
                                        />
                                    </div>
                                </div>

                                {!isGoogleAuth && (
                                    <>
                                        <div>
                                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                                Password
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    autoComplete="new-password"
                                                    required
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    className="input-primary"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                                                Confirm password
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    id="confirmPassword"
                                                    name="confirmPassword"
                                                    type="password"
                                                    autoComplete="new-password"
                                                    required
                                                    value={passwordRepeat}
                                                    onChange={(e) => setPasswordRepeat(e.target.value)}
                                                    className="input-primary"
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                                <div className="h-[20px]">
                                    {error.message && (
                                        <div className="text-red-600 text-sm text-center">
                                            <b>{error.type}</b> {error.message}
                                        </div>
                                    )}
                                </div>

                                <div className="mt-6 ">
                                    <label
                                        className={classNames(
                                            'flex items-start space-x-3 text-sm font-semibold text-gray-700 justify-center',
                                            { 'text-red-600': termsError }
                                        )}
                                    >
                                        <div className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={termsAccept}
                                                onChange={(e) => {
                                                    setTermsAccept(e.target.checked)
                                                }}
                                                className=" h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                            />
                                            <label htmlFor="emailNotifications" className="ml-2 block text-sm text-gray-900">
                                                <div className="check"></div>I agree to the{' '}
                                                <a
                                                    href="https://emissary-health-storage.s3.amazonaws.com/Emissary_Health_Terms_of_Use_2023.pdf"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >Terms</a> and{' '}
                                                <a
                                                    href="https://emissary-health-storage.s3.amazonaws.com/Emissary_Health_Privacy_Policy_10.12.2023.pdf"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >Privacy Policy</a>
                                            </label>
                                        </div>
                                    </label>
                                </div>
                                <div>
                                    <button disabled={!termsAccept} type="submit" className="w-full btn-primary">
                                        Sign up
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            )}

            {step > 0 && !finishing && (
                <Stepper
                    step={step}
                    nextStep={onNextStep}
                    userType={type}
                    signInfo={signInfo}
                    finish={finishSignup}
                    categories={cost}
                    selectCategory={selectCategory}
                    isGoogleAuth={isGoogleAuth}
                    dob={dobState}
                    onDobChange={onDobChange}
                    address={addressState}
                    onAddressChange={onAddressChange}
                    isAddressVerified={isAddressVerified}
                    setIsAddressVerified={setIsAddressVerified}
                    setCategoryRate={setCategoryRate}
                    setRate={setRate}
                    rate={rate}
                    setPhoneNumber={setPhoneNumber}
                    phoneNumber={phoneNumber}
                    setIsPhoneVerified={setIsPhoneVerified}
                />
            )}
        </div>
    )
}

export default observer(UserSignup);